function formatCurrencyWithFractionDigits(currency, numberOfDigits) {
  const currencyFormatter = new Intl.NumberFormat('en-AU', {style: 'currency', currency: 'AUD', minimumFractionDigits: numberOfDigits, maximumFractionDigits: numberOfDigits});
  return currencyFormatter.format(currency)
}

export default formatCurrencyWithFractionDigits
